import React, { useState, useRef, useEffect } from "react";
import cls from "./style.module.scss";
import useStyles from "isomorphic-style-loader/useStyles";
import { fetchHistoryOrder } from "../../../../../../../api";
import Header from "../../../../../../components/header";
import OrderList from "../fragments/order-list";
import { useCallback } from "react";
import OrderListEmpty from '../fragments/list-empty/index';
import { Iconfont } from "../../../../../../components/icon/iconfont";
import { Link } from "react-router-dom";
import { useIntl } from "react-intl";


const HistoryOrder = props =>{
    useStyles(cls);
    const Intl = useIntl();
    const skipRef = useRef(0);
    const [orderList, setOrderList] = useState([]);
    const [loading, setLoading] = useState(false);
    const [finished, setFinished] = useState(false);

    useEffect(async () =>{
        loadHandle();
    }, []);

    const loadHandle = useCallback(async () =>{
        let response = await fetchHistoryOrder(skipRef.current);
        setLoading(true);
        if(response?.code === 200 && response?.result){
            setOrderList(state=>[...state, ...response.result]);
            setFinished(response.result?.length < 20);
            skipRef.current += 20;
		}else{
            setFinished(true);
        }
        setLoading(false);
    }, []);

    return <div className={cls.HistoryOrder}>
        <Header 
            centerSlot={Intl.formatMessage({ id: "history_orders", defaultMessage: "History Orders" })} 
            rightSlot={
                <Link to={`/user/support`} className={cls.RightIcon}>
                    <Iconfont className={cls.Icon}>&#xe716;</Iconfont>
                </Link>
            }
        />

        <OrderList 
            request={loadHandle}
            orders={orderList} 
            loading={loading}
            finished={skipRef.current!==0 && finished}
        />

        {
			skipRef.current===0 && finished && <OrderListEmpty />
		}
    </div>
}

export default HistoryOrder;